import { FC } from 'react';
import useDeviceSize from '../../../../../hooks/useDeviceSize';
import { accountSwitcherStyle } from './AccountSwitcher.style';
import { Button, Divider, Flex, Link, Text, View, Alert, Spin, Tag } from '../../../../../components/Element';
import { useAccountSwitcher } from './logic/useAccountSwitcher';
import ResponsiveModalDrawer from '../../../../../components/ResponsiveModalDrawer';
import CreateAccount from '../CreateAccount';
import { listRoles } from './logic/AccountSwitcher.types';

export const AccountSwitcher: FC = () => {
  const {
    isLoading,
    error,
    isModalOpen,
    getActiveRole,
    doSwitchAccount,
    doToggleAccountSwitcher,
    doClose,
    doGoBack,
    listOfAccounts,
    modalTitle,
    onClickCreateAccount,
    pendingRoleId,
    isCreateAccountOpen,
    refetch,
  } = useAccountSwitcher();
  const device = useDeviceSize();
  const style = accountSwitcherStyle(device);

  if (isLoading) return <Spin fullscreen={false} />;
  if (error)
    return (
      <Alert
        type="error"
        message="We couldn't load your accounts."
        action={
          <Button size="small" onClick={() => refetch()}>
            Try again
          </Button>
        }
      />
    );

  return (
    <>
      <ResponsiveModalDrawer
        isOpen={isModalOpen}
        onBack={doGoBack}
        toggleOpen={doToggleAccountSwitcher}
        title={modalTitle}
        backEnabled={modalTitle !== 'Switch to Account'}
        closeEnabled={true}
        onClose={() => doClose()}
      >
        {isCreateAccountOpen ? (
          <CreateAccount refetch={refetch} />
        ) : (
          <Flex vertical={true} gap={24}>
            {listOfAccounts.map((role: listRoles) => (
              <View key={role.id} onClick={() => doSwitchAccount(role.id)}>
                <Flex style={style.selectionBox} align="center">
                  <Flex vertical={false} gap={8} justify="end" align="center">
                    <Text style={style.mainTag}>
                      {role?.companyName ||
                        (role.firstName && role.lastName && `${role.firstName} ${role.lastName}`) ||
                        role?.title}
                    </Text>
                    <Text style={style.secondaryTag}>{role?.group?.replace('_', ' ')}</Text>
                    {getActiveRole() === role.id ? <Tag color="purple">Active </Tag> : null}
                    {pendingRoleId === role.id ? <Spin /> : null}
                  </Flex>
                </Flex>
              </View>
            ))}
            <Divider style={style.solidDivider} />
            <Text style={style.createText}>
              Need a new account?{' '}
              <Link style={style.inlineLink} onClick={() => onClickCreateAccount()}>
                Create account
              </Link>
            </Text>
          </Flex>
        )}
      </ResponsiveModalDrawer>
    </>
  );
};
